var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("letter-layout", {
    attrs: {
      title: "有些遇见，从一开始就注定是遗憾",
      date: "2026年6月1日",
      "sign-date": "2026年6月1日",
      paragraphs: _vm.paragraphs,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }